export const spacingPrimitive = {
	"0": "0px",
	"0.5": "2px",
	"1": "4px",
	"1.5": "6px",
	"2": "8px",
	"2.5": "10px",
	"3": "12px",
	"4": "16px",
	"5": "20px",
	"6": "24px",
	"8": "32px",
	"10": "40px",
	"12": "48px",
	"16": "64px",
	"20": "80px",
	"24": "96px",
	"32": "128px",
	"40": "160px",
	"48": "192px",
	"56": "224px",
	"64": "256px",
	"80": "320px",
	"96": "384px",
	"120": "480px",
	"140": "560px",
	"160": "640px",
	"180": "720px",
	"192": "768px",
	"256": "1024px",
	"320": "1280px",
	"360": "1440px",
	"400": "1600px",
	"480": "1920px",
};
